import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddExerciseComponent } from './add-exercise/add-exercise.component';
import { IonicModule } from '@ionic/angular';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';
import { FormsModule } from '@angular/forms';
import { AddExistingComponent } from './add-existing/add-existing.component';
import { ExerciseFilterComponent } from './exercise-filter/exercise-filter.component';
import { SelectExerciseComponent } from './select-exercise/select-exercise.component';
import { GifSearchComponent } from './gif-search/gif-search.component';
import { ExerciseDetailComponent } from './exercise-detail/exercise-detail.component';
import { NgChartsModule } from 'ng2-charts';
import { ExerciseFromDbDetailComponent } from './exercise-from-db-detail/exercise-from-db-detail.component';
import { ExerciseFromDbComponent } from './exercise-from-db/exercise-from-db.component';
import { CreateExerciseComponent } from './create-exercise/create-exercise.component';
import { ExerciseThumbnailComponent } from './exercise-thumbnail/exercise-thumbnail.component';
import { BodyHeatmapComponent } from './body-heatmap/body-heatmap.component';
import { SelectMuscleGroupComponent } from './select-muscle-group/select-muscle-group.component';
import { StatisticsChartComponent } from './statistics-chart/statistics-chart.component';
import { PlanSummaryComponent } from 'src/components/plan-summary/plan-summary.component';
import { TimerComponent } from './timer/timer.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { GifRecorderComponent } from './gif-recorder/gif-recorder.component';
import { LogoComponent } from './logo/logo.component';
import { CalendarHistoryComponent } from './calendar-history/calendar-history.component';
import { DbExerciseImgComponent } from './db-exercise-img/db-exercise-img.component';
import { CreatePlanComponent } from './create-plan/create-plan.component';
import { RouterModule } from '@angular/router';
import { DetailChartComponent } from './exercise-detail/detail-chart/detail-chart.component';

const components = [
  AddExerciseComponent,
  AddExistingComponent,
  ExerciseFilterComponent,
  SelectExerciseComponent,
  GifSearchComponent,
  ExerciseDetailComponent,
  ExerciseFromDbComponent,
  ExerciseFromDbDetailComponent,
  CreateExerciseComponent,
  ExerciseThumbnailComponent,
  BodyHeatmapComponent,
  SelectMuscleGroupComponent,
  StatisticsChartComponent,
  PlanSummaryComponent,
  TimerComponent,
  BackButtonComponent,
  GifRecorderComponent,
  LogoComponent,
  CalendarHistoryComponent,
  DbExerciseImgComponent,
  CreatePlanComponent,
  DetailChartComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    IonicModule,
    SharedPipesModule,
    FormsModule,
    NgChartsModule,
    IonicModule.forRoot(),
    RouterModule,
  ],
  exports: components,
})
export class SharedComponentsModule {}
